import { useContext } from 'react';

import { AngularContext } from './AngularProvider';

export function useAngularIsReady() {
  const angularContext = useContext(AngularContext);
  return angularContext.isReady ?? false;
}
